import { observable } from 'mobx';
export class EnrichStore {
    constructor(...enrichers) {
        Object.defineProperty(this, "enrichers", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: observable([])
        });
        this.enrichers.replace(enrichers);
    }
    enrich(objects) {
        let enrichedObjects = objects;
        for (const enricher of this.enrichers) {
            enrichedObjects = enrichedObjects.map(enricher);
        }
        return enrichedObjects;
    }
}
//# sourceMappingURL=EnrichStore.js.map